export const DefaultIntervals = [0.2, 0.4, 1, 2, 4, 8];

export function executeFunctionInInterval(func, delays = [0.2, 0.4, 1, 2, 4, 8], stop = () => false) {
  if (delays.length === 0) return;
  if (stop()) return

  setTimeout(() => {
    func()
    delays.shift();
    executeFunctionInInterval(func, delays, stop);
  }, (delays[0] || 0) * 1000);
}

export function executeFunctionExpInt(func, stop = () => false, count = 1, starting = 100, multiplier = 2) {
  setTimeout(() => {
    func()
    if (stop(count, starting)) return
    executeFunctionExpInt(func, stop, ++count, starting * multiplier, multiplier);
  }, starting);
}
const sleep = delay =>
  new Promise(resolve => setTimeout(resolve, delay));
// Returns a promise that resolves after the Stop function is 
export async function executeFunctionExpIntP(func, stop = () => false, count = 1, starting = 100, multiplier = 2) {
  await sleep(starting);
  await func();
  if (stop(count, starting)) {
    return;
  }
  executeFunctionExpIntP(func, stop, ++count, starting * multiplier, multiplier);
}


// executeFunctionInInterval(() => console.log('Hello World', printTime()), [5, 10, 20, 40, 2, 4, 8], () => false);
// executeFunctionInInterval(() => console.log('Hello World', printTime()), DefaultIntervals, () => false);
// executeFunctionExpInt(() => console.log('Hello World', printTime()), (count, starting) => count === 10, 100, 2);
// executeFunctionExpIntP(() => console.log('Hello WorldP', printTime()), (count, starting) => count === 10, 100, 2);

// Output Current Time to the Minute and Seconds
const printTime = () => {
  const date = new Date();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();
  return `${minutes}:${seconds}`;
}